import { render, staticRenderFns } from "./proyecto.vue?vue&type=template&id=b631456c&scoped=true&"
import script from "./proyecto.vue?vue&type=script&lang=js&"
export * from "./proyecto.vue?vue&type=script&lang=js&"
import style0 from "./proyecto.vue?vue&type=style&index=0&id=b631456c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b631456c",
  null
  
)

export default component.exports